var _g, _circle, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 52,
    viewBox: "0 0 46 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1103_178545)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6276 34.3206C34.2079 32.3357 39 26.2275 39 19C39 10.1634 31.8366 3 23 3C14.1634 3 7 10.1634 7 19C7 26.2275 11.7921 32.3357 18.3724 34.3206L22.178 39.8136C22.5757 40.3876 23.4243 40.3876 23.822 39.8136L27.6276 34.3206Z",
    fill: "#FFFEFD"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 19,
    r: 14,
    fill: "#131C1C"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1103_178545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6466 23.5552C21.0211 23.5552 18.8848 21.4501 18.8848 18.8623C18.8848 16.2743 21.0211 14.1689 23.6466 14.1689C26.2727 14.1689 28.409 16.2743 28.409 18.8623C28.409 21.4501 26.2727 23.5552 23.6466 23.5552ZM23.6466 15.178C21.5857 15.178 19.9087 16.831 19.9087 18.8623C19.9087 20.8936 21.5855 22.5464 23.6466 22.5464C25.7083 22.5464 27.3848 20.8936 27.3848 18.8623C27.3848 16.8308 25.708 15.178 23.6466 15.178Z",
    fill: "#FBFAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2495 20.7444C22.1186 20.7444 21.9877 20.6952 21.8876 20.5971C21.4172 20.1341 21.1582 19.5186 21.1582 18.8632C21.1582 18.2083 21.417 17.5928 21.8868 17.1295C22.8563 16.1743 24.4349 16.1743 25.4056 17.1295C25.6055 17.3266 25.6055 17.6461 25.4056 17.8429C25.2062 18.0405 24.8817 18.0405 24.682 17.8431C24.1104 17.2804 23.1819 17.2807 22.6109 17.8431C22.3344 18.1154 22.1824 18.4775 22.1824 18.8629C22.1824 19.2483 22.3347 19.6101 22.6114 19.8824C22.8114 20.0794 22.8117 20.3989 22.6117 20.596C22.5119 20.6949 22.3807 20.7444 22.2495 20.7444Z",
    fill: "#FBFAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8245 23.6913C16.5416 23.6913 16.3125 23.4655 16.3125 23.1868V14.5407C16.3122 14.2619 16.5416 14.0361 16.8245 14.0361C17.1073 14.0361 17.3364 14.2619 17.3364 14.5407V23.1868C17.3364 23.4655 17.1071 23.6913 16.8245 23.6913Z",
    fill: "#FBFAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5676 18.0216H16.0811C15.6773 18.0216 15 17.8549 15 16.7368V14.5407C15 14.2619 15.2294 14.0361 15.512 14.0361C15.7946 14.0361 16.0239 14.2619 16.0239 14.5407V16.7368C16.0239 16.8953 16.0378 16.9743 16.0483 17.0115C16.0569 17.0123 16.0677 17.0128 16.0808 17.0128H17.5673C17.5806 17.0128 17.5914 17.0123 17.6 17.0115C17.6106 16.9743 17.6244 16.8953 17.6244 16.7368V14.5407C17.625 14.2619 17.8543 14.0361 18.1369 14.0361C18.4195 14.0361 18.6489 14.2619 18.6489 14.5407V16.7368C18.6489 17.8549 17.9714 18.0216 17.5676 18.0216Z",
    fill: "#FBFAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4885 23.6913C30.2056 23.6913 29.9766 23.4655 29.9766 23.1868V14.5407C29.9766 14.2619 30.2056 14.0361 30.4885 14.0361C30.7714 14.0361 31.0008 14.2619 31.0008 14.5407V23.1868C31.0005 23.4655 30.7711 23.6913 30.4885 23.6913Z",
    fill: "#FBFAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7466 19.3833C29.4637 19.3833 29.2344 19.1575 29.2344 18.8788V15.6777C29.2344 14.5885 29.6562 14.0361 30.4871 14.0361C30.77 14.0361 30.9993 14.2619 30.9993 14.5407C30.9993 14.8195 30.77 15.0452 30.4871 15.0452C30.3695 15.0452 30.2586 15.0452 30.2586 15.6777V18.879C30.2583 19.1575 30.0292 19.3833 29.7466 19.3833Z",
    fill: "#FBFAF8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1103_178545",
    x: 0,
    y: 0,
    width: 46,
    height: 51.2441,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0326543 0 0 0 0 0.0544626 0 0 0 0 0.0544626 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1103_178545"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1103_178545",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1103_178545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(15 11)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapDefault);
export default __webpack_public_path__ + "static/media/map_default.a3c0ef20a0cb2f423663ddbf255af772.svg";
export { ForwardRef as ReactComponent };